/** Format an RFC3339 timestamp for IAM tables; falls back to raw / em-dash. */
export function formatIamDate(raw?: string | null): string {
  if (!raw) return '—';
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? raw : d.toLocaleString();
}
